import React from 'react';
import '../Styling/documentation.css';

export default function PrivacyPolicy() {
  return (
    <div className='documentaionContainer'>
      <div className="documentationText">
        <h1 className='documentationHeading'>Privacy Policy</h1>
        <br />
        <p>Welcome to Momentous Holidays! This Privacy Policy governs the manner in which we collect, use, disclose, and safeguard your personal information as a user of our services and our website.</p>

        <br /><br />
        <h2>Information We Collect</h2>
        <ul>
          <li><strong>Name:</strong> To personalize our communication.</li>
          <li><strong>Email:</strong> To respond to your inquiries and provide information.</li>
          <li><strong>Mobile Number:</strong> To contact you for tour-related communications.</li>
          <li><strong>Questions (if any):</strong> Additional information you choose to provide.</li>
        </ul>

        <br /><br />
        <h2>How We Collect Information</h2>
        <ul>
          <li><strong>Form Submissions:</strong> When you submit information through forms on our website.</li>
          <li><strong>Cookies:</strong> We may use cookies to enhance your user experience.</li>
        </ul>

        <br /><br />
        <h2>Purpose of Collection</h2>
        <ul>
          <li>To respond to your inquiries and provide information about our services.</li>
          <li>To personalize your experience and improve our website.</li>
        </ul>

        <br /><br />
        <h2>Third-Party Services</h2>
        <p>We use third-party services, such as formsubmit.co, to collect and process your information. Please review the privacy policies of these third-party services for more information.</p>

        <br /><br />
        <h2>Data Storage and Security</h2>
        <p>Your information is stored securely with appropriate safeguards to protect against unauthorized access, disclosure, alteration, and destruction.</p>

        <br /><br />
        <h2>Data Usage</h2>
        <ul>
          <li>Responding to your inquiries and providing requested information.</li>
          <li>Improving our services and website functionality.</li>
        </ul>

        <br /><br />
        <h2>Data Sharing</h2>
        <p>We do not sell, trade, or otherwise transfer your personal information to third parties. Your information may be shared with our team members who are involved in responding to your inquiries.</p>

        <br /><br />
        <h2>User Control</h2>
        <ul>
          <li>Access your personal information.</li>
          <li>Correct inaccuracies in your personal information.</li>
          <li>Withdraw consent for processing (where applicable).</li>
        </ul>

        <br /><br />
        <h2>Data Retention</h2>
        <p>We retain your personal information for as long as necessary to fulfill the purposes outlined in this privacy policy or as required by law.</p>

        <br /><br />
        <h2>Updates to Privacy Policy</h2>
        <p>We may update this privacy policy to reflect changes in our practices. You will be notified of any material changes through the contact information provided.</p>

        <br /><br />
        <h2>Legal Compliance</h2>
        <p>We comply with applicable data protection laws, including the General Data Protection Regulation (GDPR) and the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011, of India.</p>

        <br /><br />
        <h2>Contact Information</h2>
        <p>For privacy inquiries or to exercise your rights, please <a href="/Contact">Contact Us</a> </p>

        <br /><br />
      <h3>Thank you for entrusting Momentous Holidays with your information. We are committed to safeguarding your privacy and ensuring a secure and enjoyable experience.</h3>
      </div>
    </div>
  );
}
